<template>
	<div :class="['main-container', { 'loggedIn': isLoggedIn, 'dark-mode': shouldUseDarkMode }]">
		<HeaderView v-if="!isLoginPage"/>
		<div :class="['row content-container', { 'full-width': isOpenAside && !isLoggedIn }]">
			<div class="col d-flex ">
				<AsideView  v-if="isLoggedIn && !isLoginPage"/>
			</div>
			<div :class="['page-container', { 'full-width': isOpenAside, 'dark-mode': shouldUseDarkMode }]">
				<RouterView/>
			</div>
		</div>
		<FooterView v-if="!isLoginPage"/>
	</div>
</template>

<script>
	import HeaderView from './components/common/header/HeaderView';
	import AsideView from './components/common/aside/AsideView';
	import FooterView from './components/common/footer/FooterView';
	import apiHelper from './utils/apiHelpers';
	import { mapState } from 'vuex';

	export default {
		components: {
			HeaderView,
			FooterView,
			AsideView
		},
		computed: {
			...mapState([
				'isLoggedIn',
				'isOpenAside',
				'isDarkMode',
			]),
			isLoginPage() {
				return this.$route.path === '/' || this.$route.path === '/login'
			},
			shouldUseDarkMode() {
				return this.isDarkMode && !this.isLoginPage
			}
		},
		methods: {
			async updateLoggedUserInfo(){
				const uid = this.$store.state.loggedUser?.id;
				const response = await apiHelper.getInfoById(`/users/${uid}/?account=merchant`);
				if (response.success) {
					this.$store.state.loggedUser.role_level_id = response.user.role_level_id;
					this.$store.state.loggedUser.area_group_id = response.user.area_group_id;
				} else {
					throw new Error('Unsuccessful response');
				}
			},
		},
		mounted(){
			if (this.isLoggedIn && !this.isSuperOrAdmin) {
				this.updateLoggedUserInfo();
			}
		}
	}
</script>
